module.exports = __webpack_public_path__ + "img/sm.bb640cc6.png";